import { render, staticRenderFns } from "./LocationContract.vue?vue&type=template&id=68d64ddd"
import script from "./LocationContract.vue?vue&type=script&lang=js"
export * from "./LocationContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports